export default "__VITE_ASSET__CJYNAfpN__"